module.exports = __webpack_public_path__ + "static/media/firebase-create-project.20257102.png";